<div class="extended-usp-section d-grid text-center gap-3">
  <div class="row">
    <div class="text-center offset-lg-2 col-lg-8">
      <h2 class="extended-usp-section__title" *scText="title()"></h2>
      @if (showIntroduction() && introduction(); as introduction) {
        <wl-rich-text-wrapper [field]="introduction">
          <div class="extended-usp-section__introduction"></div>
        </wl-rich-text-wrapper>
      }
    </div>
  </div>

  <ul class="row justify-content-center list-unstyled mb-0">
    @for (usp of extendedUsps(); track uid() + $index) {
      <li
        class="col-12 col-sm-6 mb-0 py-2 py-lg-0"
        [ngClass]="getExtendedUspClass()"
      >
        <wl-extended-usp
          [uid]="uid() + '-' + $index"
          [icon]="usp.icon"
          [title]="usp.title"
          [description]="usp.description"
        />
      </li>
    }
  </ul>

  @if (callToAction(); as callToAction) {
    <div class="row">
      <div class="col">
        <crnt-button-alt
          class="extended-usp-section__call-to-action"
          [inverted]="inverted()"
          variant="secondary"
        >
          <a
            *wlGenericLink="callToAction"
            wlTrackLink
            [trackLinkInfo]="{
              rendering: { componentName: 'ExtendedUspsSectionComponent' },
              field: callToAction.value?.text ?? '',
              eventType: 'link-click',
              type: 'navigation',
            }"
          ></a>
        </crnt-button-alt>
      </div>
    </div>
  }
</div>
